import { useState } from 'react';
import api from 'api';
import config from 'config';
import { useDispatch, useReduxState } from 'hooks';
import { Button } from 'components/common';

import type { ServerConfig } from 'shared-types';

interface Props {
  activationKey?: string;
  next?: string;
  registration?: boolean;
  strategy: ServerConfig['authStrategies'][0];
}

const SingleSignOn = ({
  activationKey,
  next,
  registration = false,
  strategy
}: Props) => {
  const { dispatch } = useDispatch();
  const { language, theme } = useReduxState();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    try {
      setIsLoading(true);
      await api.post('/auth/logout');

      const queryParams =
        (activationKey && strategy.type === 'strong-identification'
          ? `activationKey=${activationKey}&`
          : '') +
        (strategy.authenticateQueryString
          ? `${strategy.authenticateQueryString}&`
          : '') +
        `next=${next || '/'}`;

      window.location.href = `${config.apiUrl}/auth/${strategy.name}/authenticate?${queryParams}`;
    } catch (err) {
      setIsLoading(false);
      await dispatch.handleErrorDispatch(err);
    }
  };

  const buttonImageMargin = registration
    ? strategy.buttonRegisterImageMargin
    : strategy.buttonLoginImageMargin;

  const buttonImageWidth = registration
    ? strategy.buttonRegisterImageWidth
    : strategy.buttonLoginImageWidth;

  const buttonImageUrl = registration
    ? strategy.buttonRegisterImageUrl
    : strategy.buttonLoginImageUrl;

  const buttonText = registration
    ? strategy.buttonTextRegisterLocales?.[language] ||
      strategy.buttonTextRegister ||
      strategy.name
    : strategy.buttonTextLocales?.[language] ||
      strategy.buttonText ||
      strategy.name;

  return (
    <div className="single-sign-on">
      <Button
        customBackgroundColor={strategy.buttonColor || theme.mainColor}
        customBackgroundColorHover={
          strategy.buttonHoverColor || theme.mainColorActive
        }
        customColor={strategy.buttonTextColor || theme.mainTextColor}
        loading={isLoading}
        onClick={handleClick}
        style={{ width: '100%' }}
        {...(buttonImageUrl
          ? {
              'aria-label': buttonText,
              text: (
                <img
                  src={buttonImageUrl}
                  style={{
                    margin: buttonImageMargin,
                    maxWidth: buttonImageWidth
                  }}
                />
              )
            }
          : {
              text: buttonText
            })}
      />

      <style jsx>{`
        .single-sign-on:not(:first-child) {
          margin-top: 15px;
        }
      `}</style>
    </div>
  );
};

export default SingleSignOn;
